export const filters = {
  clients_name: {
    label: 'Client name',
  },
  clients_type: {
    label: 'Client type',
  },
  credit_notes_brand: {
    label: 'Trade name',
  },
  credit_notes_client: {
    label: 'Client',
  },
  credit_notes_doc_quarter: {
    label: 'Quarter',
  },
  credit_notes_doc_year: {
    label: 'Year',
  },
  credit_notes_status: {
    label: 'Status',
  },
  invoice_templates_brand: {
    label: 'Trade name',
  },
  invoice_templates_client: {
    label: 'Client',
  },
  invoice_templates_type: {
    label: 'Type',
  },
  invoices_brand: {
    label: 'Trade name',
  },
  invoices_client: {
    label: 'Client',
  },
  invoices_doc_quarter: {
    label: 'Quarter',
  },
  invoices_doc_year: {
    label: 'Year',
  },
  invoices_status: {
    label: 'Status',
  },
  products_activity_type: {
    label: 'Type of service',
  },
  products_categories: {
    label: 'Categories',
  },
  products_status: {
    label: 'Status',
  },
  quarter: {
    option: 'Quarter {{quarter}} - {{year}}',
  },
  quotations_brand: {
    label: 'Trade name',
  },
  quotations_client: {
    label: 'Client',
  },
  quotations_doc_quarter: {
    label: 'Quarter',
  },
  quotations_doc_year: {
    label: 'Year',
  },
  quotations_status: {
    label: 'Status',
  },
};
